import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import {
  ErrorExtraBalanceIcon,
  ErrorPaymentsIcon,
} from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/pictures';
import {
  ExtraBalanceErrorWrapperStyled as ExtraBalanceErrorWrapper,
  ExtraBalanceErrorCardStyled as ExtraBalanceErrorCard,
} from './styles/ExtraBalanceErrorStyled';

import { ExtraBalanceHeaderBottom } from '../styles/ExtraBalanceStyled';
import ErrorTemplate from '../../Errors/ErrorTemplate';
import getErrorMessage from './helpers/extraBalanceMessageError';
import Modal from '../../../shared/modal';
import { rechargeUrl } from '../../../helpers';
import { redirectInternalOrExternal } from '../../../helpers/Redirect';
import useDevice from '../../../hooks/useDevice';

const ExtraBalanceError = ({
  serviceError,
  conditions,
  retry,
  closePanel,
  markOptions,
  setPanelOverlay,
}) => {
  const { hasDebt, hasRecharged } = conditions;

  const errorMessage = getErrorMessage(hasDebt, hasRecharged, serviceError);

  const [showModalRecharge, setShowModalRecharge] = useState(false);
  const { isSafari, isMobile } = useDevice();
  const rechargePortalUrl = rechargeUrl();

  const handleIframeRender = () => {
    if (isSafari && isMobile) {
      redirectInternalOrExternal(rechargePortalUrl);
    } else setShowModalRecharge(true);
  };

  const handleVolverInicio = () => {
    navigate('/home');
    closePanel();
  };

  return (
    <>
      <ExtraBalanceErrorWrapper>
        <ExtraBalanceHeaderBottom />
        <ExtraBalanceErrorCard>
          {serviceError ? (
            <ErrorTemplate
              icon={<ErrorPaymentsIcon />}
              markOptions={markOptions}
              title={errorMessage.title}
              onClickButton={retry}
              onBackLinkClick={handleVolverInicio}
              backText="Volver"
            >
              {errorMessage.content}
            </ErrorTemplate>
          ) : (
            <ErrorTemplate
              icon={<ErrorExtraBalanceIcon />}
              title={errorMessage.title}
              markOptions={markOptions}
              buttonText="Ir a recargar"
              onClickButton={handleIframeRender}
            >
              {errorMessage.content}
            </ErrorTemplate>
          )}
        </ExtraBalanceErrorCard>
      </ExtraBalanceErrorWrapper>
      <Modal
        isShowing={showModalRecharge}
        hide={() => {
          setShowModalRecharge(false);
          setPanelOverlay(false);
        }}
      >
        <iframe
          src={rechargePortalUrl}
          title="Recarga"
          sandbox="allow-same-origin allow-top-navigation allow-scripts allow-forms allow-downloads"
        />
      </Modal>
    </>
  );
};

const markPropsShape = PropTypes.shape({
  event: PropTypes.string,
  page: PropTypes.string,
  pagename: PropTypes.string,
});

ExtraBalanceError.propTypes = {
  serviceError: PropTypes.bool.isRequired,
  conditions: PropTypes.shape({
    hasRecharged: PropTypes.bool,
    hasDebt: PropTypes.bool,
  }),
  retry: PropTypes.func.isRequired,
  closePanel: PropTypes.func.isRequired,
  markOptions: markPropsShape.isRequired,
};

ExtraBalanceError.defaultProps = {
  conditions: {
    hasRecharged: true,
    hasDebt: false,
  },
};

export default ExtraBalanceError;
